// Shopify Storefront API utilities for Subscriptions
const STOREFRONT_API_URL = `https://${process.env.REACT_APP_SHOPIFY_DOMAIN}/api/2024-01/graphql.json`;
const STOREFRONT_ACCESS_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN;

// Fetch available selling plans for a product using Storefront API
export async function getSellingPlans(productHandle) {
  console.log('🔍 Fetching selling plans for:', productHandle);
  
  const query = `
    query getProduct($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        sellingPlanGroups(first: 10) {
          edges {
            node {
              name
              options {
                name
                values
              }
              sellingPlans(first: 10) {
                edges {
                  node {
                    id
                    name
                    description
                    options {
                      name
                      value
                    }
                    priceAdjustments {
                      adjustmentValue {
                        ... on SellingPlanPercentagePriceAdjustment {
                          adjustmentPercentage
                        }
                        ... on SellingPlanFixedAmountPriceAdjustment {
                          adjustmentAmount {
                            amount
                            currencyCode
                          }
                        }
                        ... on SellingPlanFixedPriceAdjustment {
                          price {
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                    recurringDeliveries
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  try {
    console.log('📡 API URL:', STOREFRONT_API_URL);
    
    const response = await fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: { handle: productHandle }
      }),
    });

    const data = await response.json();
    console.log('📦 Full API Response:', data);
    
    if (data.errors) {
      console.error('❌ GraphQL errors:', data.errors);
      return [];
    }
    
    if (data?.data?.productByHandle?.sellingPlanGroups?.edges) {
      console.log('✅ Selling plans found:', data.data.productByHandle.sellingPlanGroups.edges);
      return data.data.productByHandle.sellingPlanGroups.edges;
    }
    
    console.log('⚠️ No selling plans found for this product');
    return [];
  } catch (error) {
    console.error('❌ Error fetching selling plans:', error);
    return [];
  }
}